import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/MagazineArticleList.vue"),
    meta: {
      title: "Magazine Articles",
    },
    name: "magazine-article-list",
    path: "/magazine_articles",
  },
  {
    component: () => import("pages/MagazineArticleEdit.vue"),
    meta: {
      title: "New Magazine Article",
    },
    name: "magazine-article-new",
    path: "/magazine_articles/new",
    props: true,
  },
  {
    component: () => import("pages/MagazineArticleEdit.vue"),
    meta: {
      title: "Edit Magazine Article",
    },
    name: "magazine-article-edit",
    path: "/magazine_articles/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/MagazineList.vue"),
    meta: {
      title: "Magazines",
    },
    name: "magazines-list",
    path: "/magazines",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/ViewerPage.vue"),
    name: "magazine-viewer",
    path: "/magazine-viewer",
    props: { sourceType: "magazine", title: "Magazine Viewer" },
  },
  {
    component: () => import("pages/MagazineEdit.vue"),
    meta: {
      title: "New Magazine",
    },
    name: "magazines-new",
    path: "/magazines/new",
    props: true,
  },
  {
    component: () => import("pages/MagazineEdit.vue"),
    meta: {
      title: "Edit Magazine",
    },
    name: "magazines-edit",
    path: "/magazines/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/PrintPageList.vue"),
    meta: {
      title: "Magazine Pages",
    },
    name: "magazine-pages-index",
    path: "/magazine-pages",
    props: { type: "magazine_page" },
  },
];
